export const HERO_IMAGE_NAMES = ['players', 'teams', 'trainers', 'tournaments', 'venues'] as const;
export type HeroImageName = (typeof HERO_IMAGE_NAMES)[number];

/** The app has no venue-owner dashboard, so it never bundles the venues hero. */
export const NATIVE_HERO_IMAGE_NAMES = ['players', 'teams', 'trainers', 'tournaments'] as const;
export type NativeHeroImageName = (typeof NATIVE_HERO_IMAGE_NAMES)[number];

export const EMPTY_STATE_ILLUSTRATIONS = [
  'bookings',
  'games',
  'teams',
  'tournaments',
  'chat',
  'notifications',
  'search',
  'clients',
] as const;
export type EmptyStateIllustration = (typeof EMPTY_STATE_ILLUSTRATIONS)[number];

export interface BrandArtwork {
  readonly src: string;
  readonly srcSet: string;
  readonly width: number;
  readonly height: number;
}

/** `sources` maps a pixel width to its URL, smallest first; the largest is the fallback. */
export function createBrandArtwork(
  sources: Readonly<Record<number, string>>,
  aspectRatio: number,
): BrandArtwork {
  const widths = Object.keys(sources)
    .map(Number)
    .sort((a, b) => a - b);
  const width = widths.at(-1)!;
  return {
    src: sources[width]!,
    srcSet: widths.map((size) => `${sources[size]} ${size}w`).join(', '),
    width,
    height: Math.round(width / aspectRatio),
  };
}
